import React from 'react';
import classNames from 'classnames';
import config from '../config';

import MultiSelect from './MultiSelect';
import Spinner from '../components/Spinner';

function Filters({ filters, selected, loading }) {
  const { countries } = filters || {};
  const hasCategoryFilters = countries && countries.length;

  const componentClass = classNames({
    'l-feed-filters': true,
  });

  return (
    <div className={componentClass} data-style-color>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="l-feed-filters__content l-jobs-feed-filters__content">
            <div className="l-jobs-feed-filters__header">
              <h2>{config.text.jobsHiringTitle}</h2>
            </div>
            <div className="l-feed-filters__filters l-jobs-feed-filters__filters">
              {!!hasCategoryFilters && (
                <div className="l-feed-filters__categories">
                  <MultiSelect
                    name="countries"
                    title={config.text.countriesTitle}
                    options={countries}
                    selected={selected.countries}
                  />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Filters;
